var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('app-page-top-section',{attrs:{"title":_vm.$t('access_logs')}}),_vm._v(" "),_c('app-table',{attrs:{"id":"access-logs-table","options":_vm.options},on:{"getFilteredValues":_vm.getFilterValues}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }